import React, { useState, useEffect, useRef } from 'react';
import {
  PageContainer, Container, Section, SectionDark, SectionLight,
  PreTitle, HeadingSerif, BodyText, ButtonOutline,
  CarouselSection, CarouselTrack, CarouselBtn,
  CorretorHeroCta, CorretorPre, CorretorCtaBtn, CorretorAreaBadge,
  CorretorSteps, CorretorStep, CorretorStepIcon, CorretorStepBadge, CorretorConnector,
} from './styles/MFRealStateStyles';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import PropertyCard from './components/PropertyCard';
import Footer from './components/Footer';
import { openContactModal } from './components/ContactModal';
import { getPublishedProperties } from './services/propertyService';
import { MF_BASE } from './basePath';

export default function MFRealStatePage() {
  const [properties, setProperties] = useState([]);
  const trackRef = useRef(null);

  useEffect(() => {
    getPublishedProperties().then(data => {
      const destaques = data.filter(p => p.destaque);
      const outros = data.filter(p => !p.destaque);
      setProperties([...destaques, ...outros]);
    });
  }, []);

  const scroll = (dir) => {
    if (!trackRef.current) return;
    const amount = 324;
    trackRef.current.scrollBy({ left: dir === 'left' ? -amount : amount });
  };

  return (
    <PageContainer>
      <Navbar />
      <HeroSection />

      {/* Selecao especial — carrossel */}
      <Section>
        <Container>
          <PreTitle>Destaques</PreTitle>
          <HeadingSerif>Seleção especial</HeadingSerif>

          <CarouselSection>
            <CarouselBtn $dir="left" onClick={() => scroll('left')}>&#8249;</CarouselBtn>
            <CarouselTrack ref={trackRef}>
              {properties.map(property => (
                <PropertyCard key={property.id} property={property} />
              ))}
            </CarouselTrack>
            <CarouselBtn $dir="right" onClick={() => scroll('right')}>&#8250;</CarouselBtn>
          </CarouselSection>

          <div style={{ textAlign: 'center', marginTop: 48 }}>
            <ButtonOutline
              as="a"
              href={`${MF_BASE}/imoveis`}
              onClick={(e) => {
                e.preventDefault();
                window.location.href = `${MF_BASE}/imoveis`;
              }}
            >
              Ver todos os imóveis
            </ButtonOutline>
          </div>
        </Container>
      </Section>

      {/* CTA Corretores */}
      <SectionDark id="corretores">
        <Container>
          <CorretorHeroCta>
            <div>
              <CorretorPre>
                <svg viewBox="0 0 24 24" width="16" height="16" fill="#C9A06A"><path d="M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4-4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>
                Para Corretores
              </CorretorPre>
              <HeadingSerif $size="lg" style={{ color: '#FFFFFF', textAlign: 'left' }}>
                Corretor Gestor de Imóveis?
              </HeadingSerif>
              <BodyText style={{ color: 'rgba(255,255,255,0.6)', maxWidth: 480, textAlign: 'left' }}>
                Cadastre-se em nosso portal. Aqui sua gestão exclusiva terá a importância que merece.
              </BodyText>
            </div>
            <CorretorCtaBtn
              href={`${MF_BASE}/seja-corretor`}
              onClick={(e) => { e.preventDefault(); window.location.href = `${MF_BASE}/seja-corretor`; }}
            >
              <svg viewBox="0 0 24 24" width="18" height="18" fill="#fff"><path d="M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4-4v2"/><circle cx="9" cy="7" r="4"/><line x1="19" y1="8" x2="19" y2="14" stroke="#fff" strokeWidth="2"/><line x1="22" y1="11" x2="16" y2="11" stroke="#fff" strokeWidth="2"/></svg>
              Cadastre-se como Corretor
            </CorretorCtaBtn>
          </CorretorHeroCta>

          <div style={{ textAlign: 'center', marginBottom: 56 }}>
            <CorretorAreaBadge>
              <svg viewBox="0 0 24 24" width="14" height="14" fill="#C9A06A"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
              Área do Corretor
            </CorretorAreaBadge>
            <HeadingSerif $size="md" style={{ color: '#FFFFFF' }}>
              Comece a vender com a gente
            </HeadingSerif>
            <BodyText style={{ color: 'rgba(255,255,255,0.55)', maxWidth: 420, margin: '0 auto' }}>
              Simples, rápido e gratuito para se cadastrar.
              <br />Veja como funciona:
            </BodyText>
          </div>

          <CorretorSteps>
            <CorretorStep $delay="0.1s">
              <CorretorStepIcon data-step="1">
                <svg className="arc" viewBox="0 0 96 96"><circle cx="48" cy="48" r="44" /></svg>
                <div className="circle">
                  <svg viewBox="0 0 24 24"><path d="M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4-4v2"/><circle cx="9" cy="7" r="4"/><line x1="19" y1="8" x2="19" y2="14"/><line x1="22" y1="11" x2="16" y2="11"/></svg>
                </div>
                <span className="num">1</span>
              </CorretorStepIcon>
              <div className="dot" />
              <h4>Faça seu cadastro</h4>
              <p>Preencha seus dados e envie seu CRECI. O processo leva menos de 3 minutos.</p>
              <CorretorStepBadge
                as="a"
                href={`${MF_BASE}/seja-corretor`}
                onClick={(e) => { e.preventDefault(); window.location.href = `${MF_BASE}/seja-corretor`; }}
                $variant="link"
              >
                Cadastrar agora
                <svg viewBox="0 0 24 24"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
              </CorretorStepBadge>
            </CorretorStep>

            <CorretorConnector><svg><line x1="0" y1="2" x2="100%" y2="2" /></svg></CorretorConnector>

            <CorretorStep $delay="0.3s">
              <CorretorStepIcon data-step="2">
                <svg className="arc" viewBox="0 0 96 96"><circle cx="48" cy="48" r="44" /></svg>
                <div className="circle">
                  <svg viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>
                </div>
                <span className="num">2</span>
              </CorretorStepIcon>
              <div className="dot" />
              <h4>Cadastre seus imóveis</h4>
              <p>Acesse o Portal do Corretor, adicione fotos, descrição e valor. Seu imóvel já sai otimizado para o Google.</p>
              <CorretorStepBadge $variant="tag">
                <svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
                SEO automático
              </CorretorStepBadge>
            </CorretorStep>

            <CorretorConnector><svg><line x1="0" y1="2" x2="100%" y2="2" /></svg></CorretorConnector>

            <CorretorStep $delay="0.5s">
              <CorretorStepIcon data-step="3">
                <svg className="arc" viewBox="0 0 96 96"><circle cx="48" cy="48" r="44" /></svg>
                <div className="circle">
                  <svg viewBox="0 0 24 24"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
                </div>
                <span className="num">3</span>
                <span className="check">
                  <svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>
                </span>
              </CorretorStepIcon>
              <div className="dot" />
              <h4>Comece a vender!</h4>
              <p>Seu imóvel já aparece para compradores e locatários em Barueri e Santana de Parnaíba.</p>
              <CorretorStepBadge
                as="a"
                href={`${MF_BASE}/seja-corretor`}
                onClick={(e) => { e.preventDefault(); window.location.href = `${MF_BASE}/seja-corretor`; }}
                $variant="link"
              >
                Quero começar
                <svg viewBox="0 0 24 24"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
              </CorretorStepBadge>
            </CorretorStep>
          </CorretorSteps>
        </Container>
      </SectionDark>

      {/* CTA */}
      <SectionLight id="contato">
        <Container style={{ textAlign: 'center' }}>
          <HeadingSerif $size="lg">
            Encontre o imóvel ideal
          </HeadingSerif>
          <BodyText $muted style={{ maxWidth: 480, margin: '0 auto 32px' }}>
            Entre em contato com nossa equipe para agendar uma visita
            ou conhecer nossas oportunidades.
          </BodyText>
          <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
            <ButtonOutline onClick={openContactModal}>
              Contato
            </ButtonOutline>
            <ButtonOutline
              as="a"
              href={`${MF_BASE}/imoveis`}
              onClick={(e) => {
                e.preventDefault();
                window.location.href = `${MF_BASE}/imoveis`;
              }}
            >
              Ver Imóveis
            </ButtonOutline>
          </div>
        </Container>
      </SectionLight>

      <Footer />
    </PageContainer>
  );
}
